import * as React from 'react';
import useHome from '../hooks/useHome';
import { ICategory } from '../types';

type CategoriesFunction = (data: Array<ICategory>) => React.ReactNode;

const isCategoriesFunction = (arg: any): arg is CategoriesFunction => {
  return typeof arg === 'function';
};

function returnChild(
  children: CategoriesFunction | React.ReactNode,
  data: Array<ICategory>
) {
  return React.isValidElement(children)
    ? { children }
    : isCategoriesFunction(children)
    ? children(data)
    : null;
}

/**
 * Group provides a way to access the categories data via a render prop.
 * */
export const Group: React.FC = ({ children }) => {
  const home = useHome();
  if (!home || !home.categories) return null;
  return <>{returnChild(children, home.categories)}</>;
};
